import { AvField } from "availity-reactstrap-validation";
import { useCallback, useState } from "react";
import { withNamespaces } from "react-i18next";
import { Col, Label, Row } from "reactstrap";
import AsyncReactSelect from "src/components/AsyncReactSelect";
import EntityManagementService from "src/apis/EntityManagementService";
import { connect } from "react-redux";

const LegalEntityQuestion = ({
    t,
    lng,
    id,
    title,
    isMandatory,
    modules,
    organization
}) => {
    const [ selectedLegalEntities, setSelectedLegalEntities ] = useState([]);

    const fetchLegalEntitiesOptions = useCallback(async (params) => {
        const entityManagementService = EntityManagementService.getInstance();
        
        const response = await entityManagementService.fetchEntitesList(
            {
                ...params,
                language_code: lng,
                organization: organization.id
            }, 
            modules.active
        );

        const options = response.legalEntities.map((entity) => {
            return {
                value: entity.id,
                label: entity.title
            }
        });

        return {
            options: options,
            pageIndex: response.pageIndex,
            pageSize: response.pageSize,
            totalCount: response.itemsCount
        }
    }, [
        lng,
        organization.id,
        modules.active
    ]);

    return (
        <Row>
            <Col sm="12">
                <div className="mb-3">
                    <Label
                        className="form-label"
                        htmlFor={`legal-question-${id}`}
                    >
                        {t(title)}
                    </Label>

                    <AsyncReactSelect 
                        loadOptions={fetchLegalEntitiesOptions}
                        settings={{
                            queryKey: 'title',
                            loadOptionsErrorMessage: 'Faild to fetch',
                            pageSize: 100
                        }}
                        value={selectedLegalEntities}
                        onChange={(e) => {
                            setSelectedLegalEntities(e)
                        }}
                        placeholder={`${t("Select")}...`}
                        isMulti
                    />

                    <AvField
                        id={`legal-question-${id}`}
                        type="hidden"
                        name={`Questien[${id}]`}
                        value={selectedLegalEntities}
                        errorMessage={t("This field cannot be blank")}
                        className="form-control"
                        validate={{
                            required: {
                                value: isMandatory
                            }
                        }}
                    />
                </div>
            </Col>
        </Row>
    )
}

const mapStatetoProps = (state) => {
    const { token, user } = state.Login;
    const { Organization, Modules } = state;
  
    return {
        token,
        user,
        modules: Modules,
        organization: Organization
    };
};

export default withNamespaces()(
    connect(
        mapStatetoProps
    )(
        LegalEntityQuestion
    )
);